import React from 'react';
import { Calendar, Zap, BarChart3 } from 'lucide-react';
export function PlatformOverview() {
  return <section id="plateforme" className="w-full font-heading" style={{
    backgroundColor: '#09090B'
  }} data-id="element-573">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 md:py-28" data-id="element-574">
        {/* Section label */}
        <p className="text-xs uppercase tracking-wider font-mono text-blue-400 text-center" data-id="element-575">
          La Plateforme
        </p>
        {/* Headline */}
        <h2 className="text-3xl md:text-4xl font-bold text-white text-center mt-4 mb-16" data-id="element-576">
          Conçue autour du cycle de vie complet de l'événement
        </h2>

        {/* Three columns */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8" data-id="element-577">
          {/* AVANT */}
          <div id="avant" className="bg-white/[0.04] border border-white/[0.08] rounded-2xl p-8" data-id="element-578">
            <div className="flex items-center gap-3 mb-6" data-id="element-579">
              <div className="w-10 h-10 rounded-xl bg-blue-500/10 flex items-center justify-center" data-id="element-580">
                <Calendar className="h-5 w-5 text-blue-400" data-id="element-581" />
              </div>
              <h3 className="text-xl font-semibold text-white" data-id="element-582">Avant</h3>
            </div>
            <ul className="space-y-4" data-id="element-583">
              <li className="flex items-start gap-3" data-id="element-584">
                <span className="mt-2 w-1.5 h-1.5 rounded-full bg-blue-400 flex-shrink-0" data-id="element-585" />
                <span className="text-white/60 text-sm leading-relaxed" data-id="element-586">
                  Portail d'inscription personnalisé
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-587">
                <span className="mt-2 w-1.5 h-1.5 rounded-full bg-blue-400 flex-shrink-0" data-id="element-588" />
                <span className="text-white/60 text-sm leading-relaxed" data-id="element-589">
                  Annuaire et profils participants
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-590">
                <span className="mt-2 w-1.5 h-1.5 rounded-full bg-blue-400 flex-shrink-0" data-id="element-591" />
                <span className="text-white/60 text-sm leading-relaxed" data-id="element-592">
                  Constructeur d'agenda et programme
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-593">
                <span className="mt-2 w-1.5 h-1.5 rounded-full bg-blue-400 flex-shrink-0" data-id="element-594" />
                <span className="text-white/60 text-sm leading-relaxed" data-id="element-595">
                  Profils speakers et sessions
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-596">
                <span className="mt-2 w-1.5 h-1.5 rounded-full bg-blue-400 flex-shrink-0" data-id="element-597" />
                <span className="text-white/60 text-sm leading-relaxed" data-id="element-598">
                  Planification de réunions 1:1
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-599">
                <span className="mt-2 w-1.5 h-1.5 rounded-full bg-blue-400 flex-shrink-0" data-id="element-600" />
                <span className="text-white/60 text-sm leading-relaxed" data-id="element-601">
                  Feed communautaire et messagerie pré-événement
                </span>
              </li>
            </ul>
          </div>

          {/* PENDANT */}
          <div id="pendant" className="bg-white/[0.04] border border-white/[0.08] rounded-2xl p-8" data-id="element-602">
            <div className="flex items-center gap-3 mb-6" data-id="element-603">
              <div className="w-10 h-10 rounded-xl bg-blue-500/10 flex items-center justify-center" data-id="element-604">
                <Zap className="h-5 w-5 text-blue-400" data-id="element-605" />
              </div>
              <h3 className="text-xl font-semibold text-white" data-id="element-606">Pendant</h3>
            </div>
            <ul className="space-y-4" data-id="element-607">
              <li className="flex items-start gap-3" data-id="element-608">
                <span className="mt-2 w-1.5 h-1.5 rounded-full bg-blue-400 flex-shrink-0" data-id="element-609" />
                <span className="text-white/60 text-sm leading-relaxed" data-id="element-610">
                  Check-in QR badge à l'entrée
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-611">
                <span className="mt-2 w-1.5 h-1.5 rounded-full bg-blue-400 flex-shrink-0" data-id="element-612" />
                <span className="text-white/60 text-sm leading-relaxed" data-id="element-613">
                  Plans de salle interactifs
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-614">
                <span className="mt-2 w-1.5 h-1.5 rounded-full bg-blue-400 flex-shrink-0" data-id="element-615" />
                <span className="text-white/60 text-sm leading-relaxed" data-id="element-616">
                  Streaming de sessions en direct
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-617">
                <span className="mt-2 w-1.5 h-1.5 rounded-full bg-blue-400 flex-shrink-0" data-id="element-618" />
                <span className="text-white/60 text-sm leading-relaxed" data-id="element-619">
                  Q&A en temps réel et sondages par session
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-620">
                <span className="mt-2 w-1.5 h-1.5 rounded-full bg-blue-400 flex-shrink-0" data-id="element-621" />
                <span className="text-white/60 text-sm leading-relaxed" data-id="element-622">
                  Capture de leads exposants via scan de badge
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-623">
                <span className="mt-2 w-1.5 h-1.5 rounded-full bg-blue-400 flex-shrink-0" data-id="element-624" />
                <span className="text-white/60 text-sm leading-relaxed" data-id="element-625">
                  Speed networking et matchmaking
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-626">
                <span className="mt-2 w-1.5 h-1.5 rounded-full bg-blue-400 flex-shrink-0" data-id="element-627" />
                <span className="text-white/60 text-sm leading-relaxed" data-id="element-628">
                  Fil communautaire et salons de discussion
                </span>
              </li>
            </ul>
          </div>

          {/* APRÈS */}
          <div id="apres" className="bg-white/[0.04] border border-white/[0.08] rounded-2xl p-8" data-id="element-629">
            <div className="flex items-center gap-3 mb-6" data-id="element-630">
              <div className="w-10 h-10 rounded-xl bg-blue-500/10 flex items-center justify-center" data-id="element-631">
                <BarChart3 className="h-5 w-5 text-blue-400" data-id="element-632" />
              </div>
              <h3 className="text-xl font-semibold text-white" data-id="element-633">Après</h3>
            </div>
            <ul className="space-y-4" data-id="element-634">
              <li className="flex items-start gap-3" data-id="element-635">
                <span className="mt-2 w-1.5 h-1.5 rounded-full bg-blue-400 flex-shrink-0" data-id="element-636" />
                <span className="text-white/60 text-sm leading-relaxed" data-id="element-637">
                  Analytique de présence et d'engagement
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-638">
                <span className="mt-2 w-1.5 h-1.5 rounded-full bg-blue-400 flex-shrink-0" data-id="element-639" />
                <span className="text-white/60 text-sm leading-relaxed" data-id="element-640">
                  Reporting de conversion des réunions
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-641">
                <span className="mt-2 w-1.5 h-1.5 rounded-full bg-blue-400 flex-shrink-0" data-id="element-642" />
                <span className="text-white/60 text-sm leading-relaxed" data-id="element-643">
                  Export des leads exposants
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-644">
                <span className="mt-2 w-1.5 h-1.5 rounded-full bg-blue-400 flex-shrink-0" data-id="element-645" />
                <span className="text-white/60 text-sm leading-relaxed" data-id="element-646">
                  Certificats de participation auto-générés
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-647">
                <span className="mt-2 w-1.5 h-1.5 rounded-full bg-blue-400 flex-shrink-0" data-id="element-648" />
                <span className="text-white/60 text-sm leading-relaxed" data-id="element-649">
                  Profils participants persistants entre événements
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-650">
                <span className="mt-2 w-1.5 h-1.5 rounded-full bg-blue-400 flex-shrink-0" data-id="element-651" />
                <span className="text-white/60 text-sm leading-relaxed" data-id="element-652">
                  Agrégation des sondages post-événement
                </span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>;
}